var _excluded = ["animations", "children", "className", "theme", "defaultTheme", "persistTheme", "scrollbars"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import AMount from "../AMount";
import { ATheme } from "../ATheme";
import "./AApp.scss";
var AApp = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$animations = _ref.animations,
    animations = _ref$animations === void 0 ? true : _ref$animations,
    children = _ref.children,
    propsClassName = _ref.className,
    theme = _ref.theme,
    defaultTheme = _ref.defaultTheme,
    _ref$persistTheme = _ref.persistTheme,
    persistTheme = _ref$persistTheme === void 0 ? false : _ref$persistTheme,
    _ref$scrollbars = _ref.scrollbars,
    scrollbars = _ref$scrollbars === void 0 ? true : _ref$scrollbars,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-app";
  if (animations) {
    className += " a-app--animated";
  }
  if (scrollbars) {
    className += " a-app--scrollbars";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  return /*#__PURE__*/React.createElement(AMount, _extends({}, rest, {
    ref: ref,
    className: className,
    component: ATheme,
    wrapClassName: "a-app--wrap",
    persist: persistTheme,
    theme: theme,
    defaultTheme: defaultTheme
  }), children);
});
AApp.propTypes = {
  /**
   * Toggles animations.
   */
  animations: PropTypes.bool,
  /**
   * Toggles styled scrollbars.
   */
  scrollbars: PropTypes.bool,
  /**
   * Toggles whether the theme is loaded from local storage on mount, and persisted to local storage on theme change.
   */
  persistTheme: PropTypes.bool,
  /**
   * Sets the default theme on mount. Changes to this prop are not reflected as a current theme.
   */
  defaultTheme: PropTypes.oneOf(["default", "dusk"]),
  /**
   * Sets the current theme. Changes to this prop are reflected as a current theme. Takes precedence over defaultTheme. Do not use "theme" and "persist" props at the same time. Providing a "theme" prop indicates that the theme is managed from outside and it will not be persisted.
   */
  theme: PropTypes.oneOf(["default", "dusk"])
};
AApp.displayName = "AApp";
export default AApp;